<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex align-center justify-space-between">
        <h2>Utenti</h2>
        <v-btn color="primary" size="small" @click="$router.push('/users/new')">Nuovo</v-btn>
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field  v-model="query.fullname" label="Nome" ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field  v-model="query.email" label="Email" ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select  v-model="query.role" label="Ruolo" :items="roles" clearable></v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <data-table :headers="headers" collection="users" editable deletable :query="query" @error="onListError">
          <template v-slot:item.surname="{ item }">
            <a @click="$router.push(`/users/${item._id}`)" ><b>{{ item.surname }}</b>, {{item.name}}</a>
          </template>
          <template v-slot:item.date_of_birth="{ item }">
            {{ calcAge(item.date_of_birth) }}
          </template>
          <template v-slot:item.seats="{ item }">
            <v-btn color="primary" variant="text" icon="mdi-seat" @click="$router.push(`/users/${item._id}/seats`)"></v-btn>
          </template>
          <template v-slot:item.role="{ item }">
            <strong v-if="item.role === UserRole.admin" class="text-error">amministratore</strong>
            <strong v-else-if="item.role === UserRole.editor" class="text-orange">editor</strong>
            <strong v-else-if="item.role === UserRole.viewer" class="text-green">visualizzatore</strong>
            <strong v-else-if="item.role === UserRole.user" class="text-blue">cliente</strong>
          </template>

        </data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import {defineComponent, ref, computed, watch, onMounted, inject, onBeforeUnmount} from 'vue'
import { useRouter } from 'vue-router'
import utils from '../utils'
import DataTable from "@/components/DataTable.vue";
import {type DataTableError, type Query, UserRole} from "@/models.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import {roles} from "@/consts.ts";
import type {Auth} from "@/plugins/auth.ts";

export default defineComponent({
  name: "UserList",
  components: {DataTable},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const router = useRouter()

    const query = ref<Query>({})
    // Methods
    const calcAge = (birth: string) => {
      const age = utils.calcAge(birth)
      return age + " anni"
    }



    let wh:any;
    onMounted(async ()=>{
      await auth.waitForLogin
      if(!auth.isAdmin.value) {
        await router.replace("/")
        return
      }

    })
    onBeforeUnmount(()=>{
      if(wh) wh();
    })
    return {
      UserRole,
      roles,
      formatDateTime : utils.formatDateTime,
      query,
      headers : [
        { title: 'Cognome e nome', sortable: true, align: 'left', value: 'surname' },
        { title: 'Email', sortable: true, align: 'left', value: 'email' },
        { title: 'Telefono', sortable: true, align: 'left', value: 'phone' },
        { title: 'Età', sortable: true, align: 'left', value: 'date_of_birth' },
        { title: 'Ruolo', sortable: true, align: 'left', value: 'role' },
        { title: 'Sedute', sortable: false, align: 'center', value: 'seats', width: 60 },
      ],
      onListError(e:DataTableError) {
        if(e.status === 401) {
          messages.error(Msg.permissionError)
          auth.logout()
          return
        }
        messages.error(`Errore: ${e.message}`)
      },
      // Methods
      calcAge,
    }
  }
})
</script>
